<template>
  <v-container fluid>
    <v-row class="mb-2" align="center">
      <v-col>
        <span class="text-h6 font-weight-bold">Pre Entregas</span>
      </v-col>
      <v-col cols="12" sm="auto" class="d-flex justify-end align-center flex-column flex-sm-row">
        <v-btn
          v-if="puedeGestionarDestinatariosPreEntrega"
          color="primary"
          outlined
          :block="$vuetify.breakpoint.xs"
          class="mr-sm-2 mb-2 mb-sm-0"
          @click="abrirGestionDestinatariosPreEntrega"
        >
          <v-icon left>fas fa-envelope</v-icon>Destinatarios alertas
        </v-btn>
        <v-btn
          color="primary"
          :loading="cargando"
          :block="$vuetify.breakpoint.xs"
          @click="actualizarPantalla"
        >
          <v-icon left>fas fa-sync</v-icon>Actualizar
        </v-btn>
      </v-col>
    </v-row>

    <v-card outlined>
      <v-card-title class="text-subtitle-1 font-weight-bold py-3">
        Vehículos para Pre Entrega
        <v-spacer />
        <v-chip small label :color="unidadesVisibles.length === unidades.length ? 'info' : 'primary'" text-color="white">
          {{ unidadesVisibles.length }} / {{ unidades.length }}
        </v-chip>
      </v-card-title>

      <v-card-text class="pa-0">
        <v-row class="pa-3" no-gutters>
          <v-col cols="12" md="4" class="pr-md-2 mb-2 mb-md-0">
            <SearchDataTable v-model="search" />
          </v-col>
          <v-col cols="12" md="4" class="px-md-1 mb-2 mb-md-0">
            <v-autocomplete
              v-model="filtroUbicacion"
              :items="ubicaciones"
              :item-text="textoUbicacion"
              item-value="nombre"
              label="Ubicación"
              outlined
              dense
              hide-details
              multiple
              clearable
              chips
              small-chips
              deletable-chips
            />
          </v-col>
          <v-col cols="12" md="4" class="pl-md-2 mb-2 mb-md-0">
            <v-autocomplete
              v-model="filtroEstado"
              :items="opcionesEstado"
              item-text="text"
              item-value="value"
              label="Estado"
              outlined
              dense
              hide-details
              clearable
            />
          </v-col>
        </v-row>

        <v-data-table
          :headers="headers"
          :items="unidadesVisibles"
          :search="search"
          :loading="cargando"
          dense
          class="elevation-0"
          :footer-props="{
            'items-per-page-options': [10, 25, 50, -1],
            'items-per-page-text': 'Filas por página',
            'show-current-page': true,
          }"
          @contextmenu:row="abrirContextMenuUniverso"
        >
          <template #item.chasis="{ item }">
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <span v-bind="attrs" class="caption font-weight-medium" v-on="on">
                  {{ vinResumen(item.chasis) }}
                </span>
              </template>
              <span>{{ vinCompleto(item.chasis) }}</span>
            </v-tooltip>
          </template>

          <template #item.ubicacion="{ item }">
            {{ item.ubicacion || '—' }}
          </template>

          <template #item.acciones="{ item }">
            <div class="d-flex align-center justify-center">
              <v-btn
                v-if="item.estado_pre_entrega === 'pendiente' && $vuetify.breakpoint.xs"
                small
                color="primary"
                @click="abrirModal(item)"
              >
                Realizar Pre Entrega
              </v-btn>

              <v-tooltip bottom v-else-if="item.estado_pre_entrega === 'pendiente'">
                <template #activator="{ on, attrs }">
                  <v-btn
                    icon
                    x-small
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    @click="abrirModal(item)"
                  >
                    <v-icon small>fas fa-wrench</v-icon>
                  </v-btn>
                </template>
                <span>Realizar Pre Entrega</span>
              </v-tooltip>

              <v-tooltip bottom v-if="item.numero_orden">
                <template #activator="{ on, attrs }">
                  <v-icon
                    small
                    color="info"
                    class="ml-1"
                    v-bind="attrs"
                    v-on="on"
                  >
                    fas fa-info-circle
                  </v-icon>
                </template>
                <span>Número de orden: {{ item.numero_orden }}</span>
              </v-tooltip>

              <v-tooltip
                v-else-if="item.estado_pre_entrega === 'rechazado' && (item.pre_entrega_observacion || item.tipo_falla)"
                bottom
              >
                <template #activator="{ on, attrs }">
                  <v-icon
                    small
                    color="warning"
                    class="ml-1"
                    v-bind="attrs"
                    v-on="on"
                  >
                    fas fa-info-circle
                  </v-icon>
                </template>
                <span>
                  <template v-if="item.tipo_falla">Tipo de falla: {{ item.tipo_falla }}. </template>
                  {{ item.pre_entrega_observacion || '' }}
                </span>
              </v-tooltip>

              <span v-else-if="item.estado_pre_entrega !== 'pendiente'" class="text--disabled caption">—</span>
            </div>
          </template>

          <template #item.estado_pre_entrega="{ item }">
            <v-chip
              x-small
              :color="estadoColor(item.estado_pre_entrega)"
              dark
            >
              {{ estadoNombre(item.estado_pre_entrega) }}
            </v-chip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- Modal Ejecutar Pre Entrega -->
    <v-dialog v-model="modal.open" max-width="700" persistent scrollable>
      <v-card>
        <v-card-title class="headline dialog-title-closable pb-2">
          <span class="dialog-title-text">Realizar Pre Entrega</span>
          <v-spacer />
          <v-btn icon class="ml-2" aria-label="Cerrar" @click="cerrarModal">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" v-model="modal.valid" lazy-validation>
            <v-row>
              <v-col cols="12">
                <div class="body-1 mb-1">VIN - {{ modal.data.vin || '—' }}</div>
                <div class="body-1">Modelo - {{ modal.data.modelo || '—' }}</div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="d-flex flex-column flex-sm-row justify-space-between align-center">
                <div class="d-flex flex-column flex-sm-row align-center pre-entrega-resultado-opciones">
                  <v-btn
                    :color="modal.data.resultado === 'exito' ? 'success' : ''"
                    :outlined="modal.data.resultado !== 'exito'"
                    :block="$vuetify.breakpoint.xs"
                    class="mr-sm-3 mb-2 mb-sm-0"
                    @click="modal.data.resultado = 'exito'"
                  >
                    <v-icon left x-small>fas fa-check-circle</v-icon>Éxito
                  </v-btn>
                  <v-btn
                    :color="modal.data.resultado === 'rechazo' ? 'error' : ''"
                    :outlined="modal.data.resultado !== 'rechazo'"
                    :block="$vuetify.breakpoint.xs"
                    class="mr-sm-3 mb-2 mb-sm-0"
                    @click="modal.data.resultado = 'rechazo'"
                  >
                    <v-icon left x-small>fas fa-times-circle</v-icon>Sin éxito
                  </v-btn>
                </div>

                <v-btn
                  :color="modal.data.resultado === 'rechazado_simple' ? 'warning' : ''"
                  :outlined="modal.data.resultado !== 'rechazado_simple'"
                  :block="$vuetify.breakpoint.xs"
                  @click="modal.data.resultado = 'rechazado_simple'"
                >
                  <v-icon left x-small>fas fa-ban</v-icon>Rechazar pre entrega
                </v-btn>
              </v-col>
            </v-row>

            <template v-if="modal.data.resultado === 'rechazo'">
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="modal.data.tipo_falla"
                    :items="tiposFalla"
                    label="Tipo de falla *"
                    :rules="reglas.tipoFalla"
                    outlined
                    dense
                    clearable
                  />
                </v-col>
              </v-row>
            </template>

            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="modal.data.observacion"
                  :label="modal.data.resultado === 'rechazo' ? 'Observación *' : 'Observaciones'"
                  :rules="modal.data.resultado === 'rechazo' ? reglas.observacionRechazo : []"
                  :rows="modal.data.resultado === 'rechazo' ? 3 : 2"
                  outlined
                  dense
                />
              </v-col>
            </v-row>

            <template v-if="modal.data.resultado !== 'rechazado_simple'">
              <v-row>
                <v-col cols="12">
                  <div class="subtitle-2 mb-2">Insumos</div>
                  <div
                    v-for="ins in insumosPredefinidos"
                    :key="ins.codigo"
                    class="d-flex align-center flex-wrap mb-2"
                  >
                    <v-checkbox
                      v-model="ins.selected"
                      hide-details
                      class="mt-0 pt-0 mr-2"
                    />
                    <span
                      class="body-2 mr-sm-4 insumo-etiqueta"
                      :class="ins.selected ? '' : 'text--disabled'"
                    >
                      {{ ins.etiqueta }}
                    </span>
                    <v-text-field
                      v-model="ins.cantidad"
                      label="Cantidad"
                      type="number"
                      step="0.01"
                      :disabled="!ins.selected"
                      outlined
                      dense
                      hide-details
                      class="insumo-cantidad mt-2 mt-sm-0"
                    />
                  </div>
                </v-col>
              </v-row>
            </template>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cerrarModal">Cancelar</v-btn>
          <v-btn
            color="primary"
            :loading="modal.guardando"
            :disabled="!modal.valid"
            @click="ejecutar"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-menu
      v-model="contextMenuUniverso.show"
      :position-x="contextMenuUniverso.x"
      :position-y="contextMenuUniverso.y"
      absolute
      offset-y
    >
      <v-list dense>
        <v-list-item
          :disabled="!contextMenuUniverso.item || contextMenuUniverso.item.estado_pre_entrega !== 'pendiente'"
          @click="ejecutarDesdeContextMenu"
        >
          <v-list-item-title style="display: flex; align-items: center;">
            <v-icon color="primary" small left>fas fa-wrench</v-icon>
            <span>Realizar Pre Entrega</span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-snackbar v-model="snackbar.value" :color="snackbar.color" top right :timeout="5000">
      {{ snackbar.text }}
      <template #action>
        <v-btn text @click="snackbar.value = false">Cerrar</v-btn>
      </template>
    </v-snackbar>

    <!-- Gestión Destinatarios Pre Entrega -->
    <v-dialog v-model="dialogGestionDestinatariosPreEntrega" max-width="840" v-if="puedeGestionarDestinatariosPreEntrega">
      <v-card>
        <v-card-title class="dialog-title-closable pb-2">
          <span class="dialog-title-text">Destinatarios de alertas de pre-entrega</span>
          <v-spacer />
          <v-btn icon class="ml-2" aria-label="Cerrar" @click="dialogGestionDestinatariosPreEntrega = false">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-6">
          <v-alert dense outlined type="info" class="mb-4">
            Gestioná los destinatarios que recibirán el aviso por correo cuando se rechace una Pre Entrega o cuando se dé de alta una unidad en DYCAR JUJUY.
          </v-alert>
          <v-row dense>
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="destinatarioPreEntregaEmpresaId"
                :items="empresas"
                item-value="Id"
                item-text="Nombre"
                label="Empresa *"
                dense
                outlined
                hide-details
                @change="cargarDestinatariosPreEntrega"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-autocomplete
                v-model="destinatarioPreEntregaTipoAlerta"
                :items="tiposDestinatarioPreEntregaAlertaOptions"
                item-value="value"
                item-text="text"
                label="Tipo de alerta *"
                dense
                outlined
                hide-details
                @change="cargarDestinatariosPreEntrega"
              />
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model.trim="destinatarioPreEntregaNuevoEmail"
                label="Email *"
                dense
                outlined
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="2" class="d-flex align-center justify-end">
              <v-btn color="success" small block :loading="guardandoDestinatarioPreEntrega" @click="crearDestinatarioPreEntrega">
                Alta
              </v-btn>
            </v-col>

            <v-col cols="12" class="mt-4">
              <v-data-table
                :headers="headersDestinatariosPreEntrega"
                :items="destinatariosPreEntregaFiltrados"
                dense
                :items-per-page="8"
                :loading="cargandoDestinatariosPreEntrega"
              >
                <template #[`item.activo`]="{ item }">
                  <v-chip x-small :color="Number(item.activo) === 0 ? 'warning' : 'success'" dark>
                    {{ Number(item.activo) === 0 ? 'INACTIVO' : 'ACTIVO' }}
                  </v-chip>
                </template>
                <template #[`item.tipo_alerta`]="{ item }">
                  {{ tipoAlertaDestinatarioPreEntregaTexto(item.tipo_alerta) }}
                </template>
                <template #[`item.acciones`]="{ item }">
                  <v-tooltip bottom>
                    <template #activator="{ on, attrs }">
                      <v-btn x-small icon color="info" v-bind="attrs" v-on="on" @click="abrirEditarDestinatarioPreEntrega(item)">
                        <v-icon small>fas fa-edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>

                  <v-tooltip v-if="Number(item.activo) !== 0" bottom>
                    <template #activator="{ on, attrs }">
                      <v-btn
                        x-small
                        icon
                        color="warning"
                        v-bind="attrs"
                        v-on="on"
                        :loading="destinatarioPreEntregaBajandoId === item.id"
                        @click="darBajaDestinatarioPreEntrega(item)"
                      >
                        <v-icon small>fas fa-ban</v-icon>
                      </v-btn>
                    </template>
                    <span>Dar de baja</span>
                  </v-tooltip>

                  <v-tooltip v-else bottom>
                    <template #activator="{ on, attrs }">
                      <v-btn
                        x-small
                        icon
                        color="success"
                        v-bind="attrs"
                        v-on="on"
                        :loading="destinatarioPreEntregaAltaId === item.id"
                        @click="darAltaDestinatarioPreEntrega(item)"
                      >
                        <v-icon small>fas fa-check</v-icon>
                      </v-btn>
                    </template>
                    <span>Dar de alta</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Editar Destinatario Pre Entrega -->
    <v-dialog v-model="dialogEditarDestinatarioPreEntrega" max-width="560">
      <v-card>
        <v-card-title class="dialog-title-closable pb-2">
          <span class="dialog-title-text">Editar destinatario de alertas de pre-entrega</span>
          <v-spacer />
          <v-btn icon class="ml-2" aria-label="Cerrar" @click="cerrarEditarDestinatarioPreEntrega">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-5">
          <v-row dense>
            <v-col cols="12">
              <v-autocomplete
                v-model="destinatarioPreEntregaEditar.empresa_id"
                :items="empresas"
                item-value="Id"
                item-text="Nombre"
                label="Empresa *"
                dense
                outlined
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                v-model="destinatarioPreEntregaEditar.tipo_alerta"
                :items="tiposDestinatarioPreEntregaAlertaOptions"
                item-value="value"
                item-text="text"
                label="Tipo de alerta *"
                dense
                outlined
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model.trim="destinatarioPreEntregaEditar.email"
                label="Email *"
                dense
                outlined
                hide-details
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cerrarEditarDestinatarioPreEntrega">Cancelar</v-btn>
          <v-btn color="primary" :loading="guardandoEdicionDestinatarioPreEntrega" @click="guardarEdicionDestinatarioPreEntrega">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import SearchDataTable from '../../../components/util/SearchDataTable.vue'

export default {
  name: 'PreEntregas',

  components: {
    SearchDataTable,
  },

  data() {
    return {
      cargando: false,
      search: '',
      filtroEstado: null,
      filtroUbicacion: [],
      unidades: [],
      ubicaciones: [],
      insumosPredefinidos: [
        { codigo: '98553890', nombre: 'Aceite de motor', etiqueta: 'Aceite de motor (98553890)', selected: false, cantidad: 1 },
        { codigo: '114796', nombre: 'Líquido de frenos', etiqueta: 'Líquido de frenos (114796)', selected: false, cantidad: 1 },
        { codigo: '101996', nombre: 'Líquido de dirección', etiqueta: 'Líquido de dirección (101996)', selected: false, cantidad: 1 },
      ],
      opcionesEstado: [
        { text: 'Todos', value: null },
        { text: 'Pendiente', value: 'pendiente' },
        { text: 'Rechazado', value: 'rechazado' },
        { text: 'Finalizado', value: 'finalizado' },
      ],
      headers: [
        { text: 'VIN', value: 'chasis' },
        { text: 'Modelo', value: 'modelo' },
        { text: 'Color', value: 'color' },
        { text: 'Ubicación', value: 'ubicacion' },
        { text: 'Pre Entrega', value: 'pre_entrega', sortable: false },
        { text: 'Estado', value: 'estado_pre_entrega', sortable: false },
        { text: 'Acciones', value: 'acciones', sortable: false, align: 'center' },
      ],
      snackbar: { value: false, text: '', color: '' },
      contextMenuUniverso: {
        show: false,
        x: 0,
        y: 0,
        item: null,
      },
      modal: {
        open: false,
        valid: false,
        guardando: false,
        rechazando: false,
        data: {
          unidad_id: null,
          vin: '',
          modelo: '',
          preventa: '',
          resultado: 'exito',
          tiempo: '',
          observacion: '',
          tipo_falla: '',
        },
      },
      tiposFalla: [
        'Falla mecánica',
        'Falla chapa y pintura',
      ],
      reglas: {
        observacionRechazo: [
          (v) => !!String(v || '').trim() || 'La observación es obligatoria en caso de rechazo.',
        ],
        tipoFalla: [
          (v) => !!v || 'El tipo de falla es obligatorio.',
        ],
      },
      // Destinatarios Pre Entrega
      permisosPreEntrega: { gestionar_destinatarios: false },
      dialogGestionDestinatariosPreEntrega: false,
      destinatarioPreEntregaEmpresaId: null,
      destinatarioPreEntregaTipoAlerta: 'pre_entrega_rechazada',
      destinatarioPreEntregaNuevoEmail: '',
      destinatariosPreEntrega: [],
      cargandoDestinatariosPreEntrega: false,
      guardandoDestinatarioPreEntrega: false,
      destinatarioPreEntregaBajandoId: null,
      destinatarioPreEntregaAltaId: null,
      dialogEditarDestinatarioPreEntrega: false,
      guardandoEdicionDestinatarioPreEntrega: false,
      destinatarioPreEntregaEditar: {
        id: null,
        empresa_id: null,
        tipo_alerta: 'pre_entrega_rechazada',
        email: '',
      },
      headersDestinatariosPreEntrega: [
        { text: 'ID', value: 'id', width: '90px' },
        { text: 'Empresa', value: 'empresa_nombre' },
        { text: 'Tipo de alerta', value: 'tipo_alerta', width: '220px' },
        { text: 'Email', value: 'email' },
        { text: 'Estado actual', value: 'activo', width: '140px' },
        { text: 'Acciones', value: 'acciones', align: 'end', sortable: false, width: '220px' },
      ],
    }
  },

  computed: {
    ...mapState('postventaTickets', ['empresas']),
    unidadesVisibles() {
      let resultado = this.unidades

      if (this.filtroEstado) {
        resultado = resultado.filter((u) => u.estado_pre_entrega === this.filtroEstado)
      }

      if (this.filtroUbicacion.length > 0) {
        resultado = resultado.filter((u) => this.filtroUbicacion.includes(u.ubicacion))
      }

      return resultado
    },
    destinatariosPreEntregaFiltrados() {
      const empresaId = Number(this.destinatarioPreEntregaEmpresaId)
      return this.destinatariosPreEntrega.filter((d) => {
        const coincideEmpresa = !Number.isInteger(empresaId) || empresaId <= 0 || Number(d.empresa_id) === empresaId
        const coincideTipo = !this.destinatarioPreEntregaTipoAlerta || d.tipo_alerta === this.destinatarioPreEntregaTipoAlerta
        return coincideEmpresa && coincideTipo
      })
    },
    tiposDestinatarioPreEntregaAlertaOptions() {
      return [
        { value: 'pre_entrega_rechazada', text: 'Pre Entrega sin éxito' },
        { value: 'unidad_alta_jujuy', text: 'Agendar turno Jujuy unidad dada de alta' },
      ]
    },
    puedeGestionarDestinatariosPreEntrega() {
      return this.permisosPreEntrega.gestionar_destinatarios === true
    },
  },

  mounted() {
    this.cargarListado()
    this.cargarUbicaciones()
    this.cargarPermisosPreEntrega()
  },

  methods: {
    async actualizarPantalla() {
      await this.cargarListado()
    },

    async cargarListado() {
      this.cargando = true
      try {
        const res = await this.$store.dispatch('postventaTickets/getPreEntregasListado')
        if (res.exito) {
          this.unidades = (res.data || []).map((u) => ({ ...u, _ejecutando: false }))
        } else {
          this.mostrarSnackbar(res.message || 'Error al cargar el listado.', 'error')
          this.unidades = []
        }
      } catch (e) {
        this.mostrarSnackbar(e.message || 'Error de red.', 'error')
        this.unidades = []
      } finally {
        this.cargando = false
      }
    },

    async cargarUbicaciones() {
      try {
        const res = await this.$store.dispatch('postventaTickets/getPreEntregasUbicaciones')
        if (res.exito) {
          this.ubicaciones = res.data || []
        }
      } catch (e) {
        console.error('Error al cargar ubicaciones', e)
      }
    },

    abrirContextMenuUniverso(event, row) {
      event.preventDefault()
      this.contextMenuUniverso.show = false
      this.contextMenuUniverso.item = row?.item || null
      this.contextMenuUniverso.x = event.clientX
      this.contextMenuUniverso.y = event.clientY
      this.$nextTick(() => {
        this.contextMenuUniverso.show = true
      })
    },

    ejecutarDesdeContextMenu() {
      const item = this.contextMenuUniverso.item
      this.contextMenuUniverso.show = false
      if (!item || item.estado_pre_entrega !== 'pendiente') return
      this.abrirModal(item)
    },

    abrirModal(item) {
      const idx = this.unidades.indexOf(item)
      if (idx === -1) return
      this.$set(this.unidades[idx], '_ejecutando', false)

      this.insumosPredefinidos.forEach((ins) => {
        ins.selected = false
        ins.cantidad = 1
      })

      this.modal.data = {
        unidad_id: item.unidad_id,
        vin: item.chasis || '',
        modelo: item.modelo || '',
        preventa: item.preventa || '',
        resultado: 'exito',
        tiempo: 0.75, // 45 minutos
        observacion: '',
        tipo_falla: '',
      }
      this.modal.valid = false
      this.modal.open = true
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.resetValidation()
      })
    },

    cerrarModal() {
      this.modal.open = false
      this.modal.guardando = false
      this.modal.rechazando = false
    },

    async rechazarPreEntrega() {
      try {
        const payload = {
          unidad_id: this.modal.data.unidad_id,
          vin: this.modal.data.vin,
          modelo: this.modal.data.modelo,
          observacion: this.modal.data.observacion,
        }
        const res = await this.$store.dispatch('postventaTickets/rechazarPreEntrega', payload)
        if (res.exito) {
          this.mostrarSnackbar(res.message || 'Pre Entrega rechazada.', 'success')
          this.cerrarModal()
          await this.cargarListado()
        } else {
          const msg = res.error === 'PRE_ENTREGA_ACTIVA'
            ? 'Ya existe una Pre Entrega activa o finalizada para esta unidad.'
            : (res.message || 'Error al rechazar la Pre Entrega.')
          this.mostrarSnackbar(msg, 'warning')
        }
      } catch (e) {
        this.mostrarSnackbar(e.message || 'Error de red.', 'error')
      } finally {
        this.modal.guardando = false
      }
    },

    async ejecutar() {
      if (this.modal.data.resultado === 'rechazado_simple') {
        this.modal.guardando = true
        await this.rechazarPreEntrega()
        return
      }

      if (!this.$refs.form.validate()) return

      this.modal.guardando = true
      const insumosSeleccionados = this.insumosPredefinidos
        .filter((i) => i.selected && Number(i.cantidad) > 0)
        .map((i) => ({
          codigo: i.codigo,
          nombre: i.nombre,
          descripcion: i.etiqueta,
          cantidad: Number(i.cantidad),
        }))

        const payload = {
          unidad_id: this.modal.data.unidad_id,
          vin: this.modal.data.vin,
          modelo: this.modal.data.modelo,
          tiempo: this.modal.data.tiempo,
        insumos: insumosSeleccionados,
        observacion: this.modal.data.observacion,
        resultado: this.modal.data.resultado,
        tipo_falla: this.modal.data.tipo_falla,
      }

      try {
        const res = await this.$store.dispatch('postventaTickets/ejecutarPreEntrega', payload)
        if (res.exito) {
          let mensaje = res.message || 'Operación exitosa.'
          if (res.data?.orden_control) {
            mensaje = `Pre Entrega realizada con éxito. OS ${res.data.orden_control}`
          }
          this.mostrarSnackbar(mensaje, 'success')

          // Actualizar la fila in-place para feedback inmediato
          const idx = this.unidades.findIndex((u) => u.unidad_id === this.modal.data.unidad_id)
          if (idx !== -1) {
            const updated = {
              ...this.unidades[idx],
              estado_pre_entrega: 'finalizado',
              numero_orden: res.data.orden_servicio_id || res.data.orden_control,
              ticket_id: res.data.ticket_id,
              pre_entrega_id: res.data.pre_entrega_id,
            }
            this.$set(this.unidades, idx, updated)
          }

          this.cerrarModal()
          await this.cargarListado()
        } else {
          const msg = res.error === 'PRE_ENTREGA_ACTIVA'
            ? 'Ya existe una Pre Entrega activa o finalizada para esta unidad.'
            : (res.message || 'Error al ejecutar la Pre Entrega.')
          this.mostrarSnackbar(msg, 'warning')
        }
      } catch (e) {
        this.mostrarSnackbar(e.message || 'Error de red.', 'error')
      } finally {
        this.modal.guardando = false
      }
    },

    mostrarSnackbar(text, color = 'info') {
      this.snackbar = { value: true, text, color }
    },

    vinCompleto(vin) {
      return String(vin || '').trim() || '—'
    },

    vinResumen(vin) {
      const limpio = this.vinCompleto(vin)
      if (limpio === '—') return limpio
      if (limpio.length <= 8) return limpio
      return `...${limpio.slice(-8)}`
    },

    estadoColor(estado) {
      if (estado === 'pendiente') return 'blue'
      if (estado === 'finalizado') return 'green'
      if (estado === 'rechazado') return 'red'
      return 'grey'
    },

    estadoNombre(estado) {
      if (estado === 'pendiente') return 'Pendiente'
      if (estado === 'finalizado') return 'Finalizado'
      if (estado === 'rechazado') return 'Rechazado'
      return 'Desconocido'
    },

    textoUbicacion(item) {
      if (!item) return ''
      const localidad = item.localidad ? ` - ${item.localidad}` : ''
      return `${item.nombre}${localidad}`
    },

    // --- Destinatarios Pre Entrega ---

    async cargarPermisosPreEntrega() {
      try {
        const res = await this.$store.dispatch('postventaTickets/getPreEntregasPermisos')
        if (res?.exito && res.data) {
          this.permisosPreEntrega = {
            gestionar_destinatarios: res.data.gestionar_destinatarios === true,
          }
        } else {
          this.permisosPreEntrega = { gestionar_destinatarios: false }
        }
      } catch (e) {
        this.permisosPreEntrega = { gestionar_destinatarios: false }
      }
    },

    validarEmail(valor) {
      const email = String(valor || '').trim()
      if (!email) return false
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    },

    async abrirGestionDestinatariosPreEntrega() {
      if (!this.puedeGestionarDestinatariosPreEntrega) return
      if (!Array.isArray(this.empresas) || this.empresas.length === 0) {
        await this.$store.dispatch('postventaTickets/getEmpresas')
      }
      if (!this.destinatarioPreEntregaEmpresaId && Array.isArray(this.empresas) && this.empresas.length > 0) {
        this.destinatarioPreEntregaEmpresaId = this.empresas[0].Id
      }
      this.dialogGestionDestinatariosPreEntrega = true
      await this.cargarDestinatariosPreEntrega()
    },

    async cargarDestinatariosPreEntrega() {
      this.cargandoDestinatariosPreEntrega = true
      try {
        const payload = { tipo_alerta: this.destinatarioPreEntregaTipoAlerta }
        if (this.destinatarioPreEntregaEmpresaId) payload.empresa_id = this.destinatarioPreEntregaEmpresaId
        const res = await this.$store.dispatch('postventaTickets/getDestinatariosPreEntrega', payload)
        if (res.exito) {
          this.destinatariosPreEntrega = Array.isArray(res.data) ? res.data : []
        } else {
          this.mostrarSnackbar(res.message || 'No se pudieron cargar los destinatarios.', 'error')
        }
      } finally {
        this.cargandoDestinatariosPreEntrega = false
      }
    },

    async crearDestinatarioPreEntrega() {
      if (!this.destinatarioPreEntregaEmpresaId || !this.destinatarioPreEntregaTipoAlerta || !this.validarEmail(this.destinatarioPreEntregaNuevoEmail)) {
        this.mostrarSnackbar('Debe indicar empresa, tipo de alerta y un email válido.', 'warning')
        return
      }
      this.guardandoDestinatarioPreEntrega = true
      try {
        const res = await this.$store.dispatch('postventaTickets/altaDestinatarioPreEntrega', {
          empresa_id: this.destinatarioPreEntregaEmpresaId,
          tipo_alerta: this.destinatarioPreEntregaTipoAlerta,
          email: this.destinatarioPreEntregaNuevoEmail,
        })
        if (res.exito) {
          this.destinatarioPreEntregaNuevoEmail = ''
          await this.cargarDestinatariosPreEntrega()
          this.mostrarSnackbar(res.message || 'Destinatario dado de alta.', 'success')
        } else {
          this.mostrarSnackbar(res.message || 'No se pudo crear el destinatario.', 'error')
        }
      } finally {
        this.guardandoDestinatarioPreEntrega = false
      }
    },

    abrirEditarDestinatarioPreEntrega(item) {
      this.destinatarioPreEntregaEditar = {
        id: item.id,
        empresa_id: item.empresa_id,
        tipo_alerta: item.tipo_alerta || 'pre_entrega_rechazada',
        email: item.email || '',
      }
      this.dialogEditarDestinatarioPreEntrega = true
    },

    cerrarEditarDestinatarioPreEntrega() {
      this.dialogEditarDestinatarioPreEntrega = false
      this.destinatarioPreEntregaEditar = {
        id: null,
        empresa_id: null,
        tipo_alerta: this.destinatarioPreEntregaTipoAlerta || 'pre_entrega_rechazada',
        email: '',
      }
    },

    tipoAlertaDestinatarioPreEntregaTexto(tipo) {
      const hit = this.tiposDestinatarioPreEntregaAlertaOptions.find((item) => item.value === tipo)
      return hit ? hit.text : (tipo || '—')
    },

    async guardarEdicionDestinatarioPreEntrega() {
      if (!this.destinatarioPreEntregaEditar.id || !this.destinatarioPreEntregaEditar.empresa_id || !this.destinatarioPreEntregaEditar.tipo_alerta || !this.validarEmail(this.destinatarioPreEntregaEditar.email)) {
        this.mostrarSnackbar('Debe indicar empresa, tipo de alerta y un email válido.', 'warning')
        return
      }
      this.guardandoEdicionDestinatarioPreEntrega = true
      try {
        const res = await this.$store.dispatch('postventaTickets/editarDestinatarioPreEntrega', this.destinatarioPreEntregaEditar)
        if (res.exito) {
          this.cerrarEditarDestinatarioPreEntrega()
          await this.cargarDestinatariosPreEntrega()
          this.mostrarSnackbar(res.message || 'Destinatario actualizado con éxito.', 'success')
        } else {
          this.mostrarSnackbar(res.message || 'No se pudo actualizar el destinatario.', 'error')
        }
      } finally {
        this.guardandoEdicionDestinatarioPreEntrega = false
      }
    },

    async darBajaDestinatarioPreEntrega(item) {
      this.destinatarioPreEntregaBajandoId = item.id
      try {
        const res = await this.$store.dispatch('postventaTickets/bajaDestinatarioPreEntrega', { id: item.id })
        if (res.exito) {
          await this.cargarDestinatariosPreEntrega()
          this.mostrarSnackbar(res.message || 'Destinatario dado de baja.', 'success')
        } else {
          this.mostrarSnackbar(res.message || 'No se pudo dar de baja el destinatario.', 'error')
        }
      } finally {
        this.destinatarioPreEntregaBajandoId = null
      }
    },

    async darAltaDestinatarioPreEntrega(item) {
      this.destinatarioPreEntregaAltaId = item.id
      try {
        const res = await this.$store.dispatch('postventaTickets/reactivarDestinatarioPreEntrega', { id: item.id })
        if (res.exito) {
          await this.cargarDestinatariosPreEntrega()
          this.mostrarSnackbar(res.message || 'Destinatario dado de alta.', 'success')
        } else {
          this.mostrarSnackbar(res.message || 'No se pudo dar de alta el destinatario.', 'error')
        }
      } finally {
        this.destinatarioPreEntregaAltaId = null
      }
    },
  },
}
</script>

<style scoped>
/* Título de diálogo con botón de cierre: el texto se ajusta y el botón queda en la primera fila, a la derecha. */
.dialog-title-closable {
  flex-wrap: nowrap;
}

.dialog-title-text {
  flex: 1 1 auto;
  min-width: 0;
}

/* Insumos: en escritorio la etiqueta y la cantidad comparten fila. */
.insumo-etiqueta {
  min-width: 200px;
}

.insumo-cantidad {
  max-width: 130px;
}

/* Mobile: los botones de resultado y los insumos se apilan a ancho completo. */
@media (max-width: 599px) {
  .pre-entrega-resultado-opciones {
    width: 100%;
  }

  .insumo-etiqueta {
    min-width: 0;
  }

  .insumo-cantidad {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>
